import * as React from "react";
import { LabelledSelect } from "../../customFormComponents/LabelledSelect";
import { CheckBoxGroup } from "../../customFormComponents/CheckBoxGroup/CheckBoxGroup";
import { LanguageCodes } from "../../../constants/languages";
import { ILabelSelect } from "../../../services/Language/Types";

interface ILanguageSelectionTabProps {
    usableLanguagesLabel: string;
    selectDefaultLanguageLabel: string;
    defaultLanguage: LanguageCodes;
    languageOptions: Array<{ label: string, checked: boolean, disabled: boolean, value: LanguageCodes, optionId: string }>;
    defaultLanguagesOptions: ILabelSelect[];
    onLanguageSelectionChange: (checked: boolean, languageCode: LanguageCodes) => void;
    changeDefaultLanguage: (languageCode: LanguageCodes) => void;
}

export const LanguageSelectionTab = (props: ILanguageSelectionTabProps) => (
    <div style={{ margin: "0px 28px" }}>
        <CheckBoxGroup
            componentId="language-selection"
            title={props.usableLanguagesLabel}
            onChange={(checked: boolean, languageCode: LanguageCodes) => props.onLanguageSelectionChange(checked, languageCode)}
            options={props.languageOptions}
        />
        <div style={{ width: "100%", textAlign: "center" }}>
            <div style={{ width: "390px", display: "inline-block" }}>
                {
                    props.defaultLanguagesOptions.length > 1 &&
                    <LabelledSelect
                        id="languageDefaultSelection"
                        labelText={props.selectDefaultLanguageLabel}
                        value={props.defaultLanguage}
                        options={props.defaultLanguagesOptions}
                        onChange={(val) => props.changeDefaultLanguage(val as LanguageCodes)}
                    />
                }
            </div>
        </div>
    </div>
)


// WEBPACK FOOTER //
// ./src/components/AdminSetupPage/Tabs/LanguageSelectionTab.tsx